<template style="color: var(--primary-color); background-color: var(--primary-color);">
    <div class="footer" id="footer" @mouseover="expandMenu(true)" @mouseleave="expandMenu(false)" v-if="isLoggedIn && !hideFooter">
      <router-link to="/match" class="footer-option">
        <div class="icon-wrapper">
          <img src="../assets/images/match.svg" id="home" :class="{active: activeSection === 'home' || activeSection === 'match'}">
          <span class="badge" v-if="unvotedProfilesCount > 0">{{ unvotedProfilesCount > 99 ? '99+' : unvotedProfilesCount }}</span>
        </div>
        <h4 class="menu-text">Matches</h4>
      </router-link>
      <router-link to="/pool-settings" class="footer-option">
        <div class="icon-wrapper">
          <img src="../assets/images/group.svg" id="pool-settings" :class="{active: activeSection === 'pool-settings'}">
        </div>
        <h4 class="menu-text">Gruppe Verwalten</h4>
      </router-link>
      <router-link to="/vote-overview" class="footer-option">
        <div class="icon-wrapper">
          <img src="../assets/images/user_list.svg" id="vote-overview" :class="{active: activeSection === 'vote-overview'}">
        </div>
        <h4 class="menu-text">Bewertungsübersicht</h4>
      </router-link>
      <router-link to="/chat" class="footer-option">
        <div class="icon-wrapper">
          <img src="../assets/images/chat.svg" id="chat" :class="{active: activeSection === 'chat'}">
          <span class="badge" v-if="unreadChatCount > 0">{{ unreadChatCount > 99 ? '99+' : unreadChatCount }}</span>
        </div>
        <h4 class="menu-text">Chat</h4>
      </router-link>
      <router-link to="/account" class="footer-option">
        <div class="icon-wrapper">
          <img src="../assets/images/account.svg" id="account" :class="{active: activeSection === 'account'}">
        </div>
        <h4 class="menu-text">Dein Profil</h4>
      </router-link>
    </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
export default {
  name: 'FooterMenu',
  data() {
    return {
      isLoggedIn: !!this.$store.getters.isLoggedIn,
      hideFooter: false,
      unreadChatCount: 0,
      unvotedProfilesCount: 0
    };
  },
  watch:{
    $route (){
      this.checkLoginStatus()
      this.loadCounts()
    },
    '$store.state.vote_tick' () {
      this.loadCounts()
    }
  },
  computed: {
    activeSection() {
      return this.$route.name;
    }
  },
  mounted() {
    this.checkLoginStatus();
    this.loadCounts();
  },
  methods: {
    checkLoginStatus(){
      this.isLoggedIn = !!this.$store.getters.isLoggedIn;

      this.hideFooter = (!!this.$route.query.c || this.$route.path.includes('/privacy'));
    },
    async loadCounts() {
      if (!this.isLoggedIn) return;
      try {
        const pools = await AuthService.getUserJoinedPools();
        if (pools.success) {
          this.unreadChatCount = pools.msg.reduce((sum, pool) => sum + (pool.unreadMessages || 0), 0);
        }
      } catch (e) {
        console.error(e);
      }
      try {
        const filters = await this.loadActivePoolFilters();
        const unvoted = await AuthService.getUnvotedProfilesCount(filters);
        if (unvoted.success) {
          this.unvotedProfilesCount = unvoted.msg;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async loadActivePoolFilters() {
      try {
        const user = await AuthService.getUser();
        const poolId = user?.msg?.[0]?.last_selected_pool;
        if (!poolId) return {};
        const stored = localStorage.getItem('match_filters_' + poolId);
        return stored ? JSON.parse(stored) : {};
      } catch (e) {
        return {};
      }
    },
    expandMenu(expand = false) {
      if(expand){
        document.getElementById("footer").classList.add("active");

        let elements = document.getElementsByClassName("menu-text")
        for(let i in elements){
          if(elements[i].style !== undefined){
            elements[i].style.maxWidth = "500px";
            elements[i].style.marginLeft = "15px";
            elements[i].style.marginRight = "15px";
            elements[i].classList.add("active");
          }
        }
      } else {
        document.getElementById("footer").classList.remove("active");

        let elements = document.getElementsByClassName("menu-text")
        for(let i in elements){
          if(elements[i].style !== undefined) {
            elements[i].style.maxWidth = "0";
            elements[i].style.marginLeft = "0";
            elements[i].style.marginRight = "0";
            elements[i].classList.remove("active");
          }
        }
      }
    }
  }
};
</script>

<style scoped>
h4 {
  color: #ffffff;
  text-align: center;
  font-size: 1rem;
  text-decoration: none;
}

a {
  text-decoration: none;
}

p {
  color: #ffffff;
  margin-top: 30px;
}

.footer {
  padding-bottom: 20px;
  width: 100vw;
  background: rgba(28, 28, 30, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  transition: all 0.2s ease;
  position: fixed;
  bottom: 0;
  z-index: 1000;
}

.footer img {
  background: none;
  width: 40px;
  height: 40px;
  margin: 0;
  margin-top: 5px;
  padding: 2px 2px;
  color: #ffffff;
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(285deg) brightness(106%) contrast(104%);
}

.footer img.active {
  width: 40px;
  height: 40px;
  background: #ffffff;
  filter: none;
  border-radius: 8px;
}

.footer-option {
  display: flex;
  align-items: center;
}

.menu-text {
  max-width: 0;
  overflow: hidden;
  transition: all 0.2s ease;
  white-space: nowrap;
  margin: 0;
}

.icon-wrapper {
  position: relative;
  display: inline-flex;
}

.badge {
  position: absolute;
  top: -2px;
  right: -6px;
  background: #FF3B30;
  color: white;
  font-size: 0.65rem;
  font-weight: 800;
  min-width: 17px;
  height: 17px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-sizing: border-box;
  box-shadow: 0 0 0 2px rgba(28, 28, 30, 0.95);
}

@media only screen and (min-width: 600px) {
  .footer {
    background: rgba(28, 28, 30, 0.9);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    border-top: none;
    flex-direction: column;
    position: sticky;
    top: 0;
    left: 0;
    justify-content: flex-start;
    width: auto;
    padding: 10px;
  }

  .footer.active {
    background: rgba(36, 36, 38, 0.95);
    transition: all 0.2s ease;
    box-shadow: 10px 0 30px rgba(0,0,0,0.3);
  }

  .footer h4 {
    margin-bottom: 0;
  }

  .footer img {
    margin: 0;
  }

  .footer-option {
    margin-top: 15px;
  }
}

@media only screen and (max-width: 600px) {
  .menu-text {
    display: none;
  }

  h4 {
    font-size: 0.8rem;
  }
}
</style>
